<template>
  <div>
    <div class="card">
      <div class="card card-custom">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('setting.users_list') }}<span class="card-label text-primary text-uppercase" style="font-size:large;margin-left: 15px">{{departmentData?.name}}</span> </h3>
          </div>
          <hr>
          <div class="card-toolbar" >
            <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_DEPARTMENT)" type="new" btn-text="user.add_user" @click="openCreateModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_UsersOfdepartment" style="margin-top: 13px !important; cursor:pointer">
            <thead>
              <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th> {{$t("user.lastname")}}</th>
              <th>{{$t("user.firstname")}}</th>
              <th>{{$t("actions")}}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    <AddUsers
        id="create_departmentUser"
        :departmentId="id"
        @reloadDatatable="reloadDatatable"
        :reloadUsers="reloadUsers"
    />

  </div>
</template>

<script setup>

import { useRoute } from "vue-router"
import { useI18n } from 'vue-i18n'
import {useStore} from "vuex";
import { BASE_URL } from '../../../../services/api'
import Ls from "../../../../services/ls"
import {onMounted, ref, computed, watch, nextTick} from "vue"
import AddUsers from "@/components/department/AddUsers";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import {useHasAbility} from "@/composables/hasAbility";

const {showSwal} = useSwal()
const { t } = useI18n({ useScope: 'global' })
const { can } = useHasAbility()

const route = useRoute()

const id = ref(route.params.id)

const store = useStore()

const reloadUsers=ref(false)

const table = ref(null)

const {locale, datatableLocaleUrl} = useLocales()
const departmentData = ref(null)

const loadDepartment = async (id) => {
  try {
    const response = await store.dispatch('department/getDepartment', id)
    departmentData.value = response.data.data
  } catch (error) {
    console.error('Error loading department:', error)
  }
}

onMounted(() => {
  fetchDepatments('kt_datatable_UsersOfdepartment')
  loadDepartment(route.params.id)

})

watch(() => locale.value, () => {
  nextTick(() =>  fetchDepatments('kt_datatable_UsersOfdepartment') )
})

function fetchDepatments(tableId){
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')
  
  table.value = $("#" + tableId).DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'asc']],
    ajax: {
      url: BASE_URL + '/get/department/' + route.params.id + '/users/datatables',
      type: "GET",
      beforeSend: function (request, options) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
      }
    },
    columns: [{ data: "lastname" },{ data: "firstname" }, { data: "Actions", responsivePriority: -1 }],
    columnDefs: [
      {
        targets: -3,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t + "</span>";
        },
      },
      {
        targets: -2,
        order: "desc",
        render: function (t, a, e, l) {
          return '<span>' + t + "</span>";
        },
      },
      {
        width: "10%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => {
          let render=""

          if (can(abilities.DELETE_DEPARTMENT)) {
            render += '<a href="javascript:;"  data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn"><i  data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'"  data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('button.delete')+'" ></i></a>'
          }

          return render
        },
      },
    ],
    language: {
      url:  datatableLocaleUrl.value
    }
  });
}

function openCreateModal(){
  reloadUsers.value=true
  $('#kt_modal_create_departmentUser').modal('toggle')
}

function reloadDatatable(){
  table.value.ajax.reload()
  reloadUsers.value=false
}

$(document).on("click", "#kt_datatable_UsersOfdepartment .delete_btn", (e) => {
  deleteDepartmentUser(e.target.getAttribute('data-id'))
});


async function deleteDepartmentUser(id){
  const data = {user_id:id}
  showSwal(
      '',
      i18n.global.t('swal.departmentUser_deleting')
  ).then( async (result) => {
      if (result.value) {
        try {
          await store.dispatch('department/deleteUserOfDepartment', data)
          reloadUsers.value=true
          reloadDatatable()
          window.toastr.success(t('notification.departmentUser_deleted'))
        }catch (e) {

        }
      }
  })
}

</script>
